module.exports = __webpack_public_path__ + "img/icon-ubicacion.056c2c1f.svg";